const speakerModel = {
    speakers: [
    ]
}

export default speakerModel;

// format: id, name, image
// same as guests
